import gql from 'graphql-tag';

export const LIST_PLACES_QUERY = gql`
  query ListPlaces(
    $first: Int
    $last: Int
    $after: Cursor
    $before: Cursor
    $query: String
  ) {
    places(
      first: $first
      last: $last
      after: $after
      before: $before
      query: $query
    ) @connection(key: "places") {
      edges {
        node {
          id
          name
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;
